<!-- todo ratio is now set doubled: once on the carousel and once on the picture. can we skip the carousel? -->
<pai-carousel [interval]="data().interval ?? 0" [data]="data().images ?? []" [style.--img-carousel-ratio]="ratio()">
  <ng-template paiCarouselItem let-img>
    <picture
      class="cmp-img-carousel__item"
      [paiPicture]="img"
      [mode]="img.imageOptions?.objectFit"
      [ratio]="img.imageOptions?.ratio"
      sizeSm="100vw"
      [sizeLg]="maxWidthLg"
      [sizeXl]="maxWidthXl"
      size="50vw"
    ></picture>
  </ng-template>
</pai-carousel>
